// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._bidding {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.24);
  width: 350px;
  max-height: 90vh;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  padding: 20px;
}
._bidding ._bidding_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
._bidding ._bidding_header img.avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
._bidding ._bidding_header .fs-16 {
  font-weight: bold;
  color: #ffffff;
}
._bidding ._bidding_header ._cp {
  cursor: pointer;
}
._bidding ._auction_price_container {
  margin: 20px 0;
  padding: 10px 0;
  background-color: rgba(64, 64, 64, 0.7);
  border-radius: 10px;
  text-align: center;
}
._bidding ._auction_price_container ._auctioned_price {
  display: flex;
  justify-content: center;
  align-items: center;
}
._bidding ._auction_price_container ._auctioned_price ._auction_text {
  color: #d5d5d5;
  margin-right: 8px;
}
._bidding ._bidding_body {
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}
._bidding ._bidding_input {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
._bidding ._bidding_input ._bidding_input_box {
  width: 80%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid rgba(64, 64, 64, 0.5);
  border-radius: 8px;
  background-color: rgba(30, 30, 30, 0.8);
  color: #ffffff;
}
._bidding ._bidding_input ._bidding_dropdown {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
._bidding ._bidding_input ._bidding_dropdown ._bidding_coin {
  display: flex;
  align-items: center;
  cursor: pointer;
}
._bidding ._bidding_input ._bidding_dropdown ._bidding_menu {
  position: absolute;
  top: -40px;
  right: 0;
  background-color: rgba(30, 30, 30, 0.9);
  border-radius: 10px;
  padding: 5px 0;
}
._bidding ._bidding_input ._bidding_dropdown ._bidding_menu p {
  padding: 8px 15px;
  color: #d5d5d5;
  cursor: pointer;
}
._bidding ._bidding_input ._bidding_dropdown ._bidding_menu p:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
._bidding ._bidding_fast {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}
._bidding ._bidding_fast ._bidding_fast_input {
  display: flex;
  gap: 5px;
  align-items: center;
}
._bidding ._bidding_button {
  margin-top: 20px;
  width: 100%;
}
._bidding ._bidding_button Button {
  font-size: 17px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}
._bidding ._bidding_button Button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/BiddingPopup/index.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,iDAAA;AACR;AACQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;AACZ;AAEQ;EACI,iBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,eAAA;AADZ;AAKI;EACI,cAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;AAHR;AAKQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAKY;EACI,cAAA;EACA,iBAAA;AAHhB;AAQI;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AANR;AASI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAPR;AASQ;EACI,UAAA;EACA,aAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,uCAAA;EACA,cAAA;AAPZ;AAUQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AARZ;AAUY;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AARhB;AAWY;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,uCAAA;EACA,mBAAA;EACA,cAAA;AAThB;AAWgB;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AATpB;AAUoB;EACI,0CAAA;AARxB;AAeI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAbR;AAeQ;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAbZ;AAiBI;EACI,gBAAA;EACA,WAAA;AAfR;AAiBQ;EACI,eAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;AAfZ;AAgBY;EACI,0CAAA;AAdhB","sourcesContent":["._bidding {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n    background-color: rgba(0, 0, 0, 0.6); // Dark, semi-transparent background\n    backdrop-filter: blur(10px); // Frosted glass effect\n    border-radius: 12px;\n    border: 2px solid rgba(255, 255, 255, 0.24);\n    width: 350px;\n    max-height: 90vh;\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);\n    overflow-y: auto;\n    padding: 20px;\n\n    ._bidding_header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 5px 15px 0;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n        img.avatar {\n            border-radius: 50%;\n            width: 40px;\n            height: 40px;\n            margin-right: 10px;\n            border: 1px solid rgba(255, 255, 255, 0.3); // Light border for enhanced frosted feel\n        }\n\n        .fs-16 {\n            font-weight: bold;\n            color: #ffffff;\n        }\n\n        ._cp {\n            cursor: pointer;\n        }\n    }\n\n    ._auction_price_container {\n        margin: 20px 0;\n        padding: 10px 0;\n        background-color: rgba(64, 64, 64, 0.7); // Slight transparency\n        border-radius: 10px;\n        text-align: center;\n\n        ._auctioned_price {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            ._auction_text {\n                color: #d5d5d5;\n                margin-right: 8px;\n            }\n        }\n    }\n\n    ._bidding_body {\n        padding: 10px;\n        max-height: 300px;\n        overflow-y: auto;\n    }\n\n    ._bidding_input {\n        display: flex;\n        align-items: center;\n        margin-top: 15px;\n\n        ._bidding_input_box {\n            width: 80%;\n            padding: 10px;\n            font-size: 16px;\n            border: 1px solid rgba(64, 64, 64, 0.5);\n            border-radius: 8px;\n            background-color: rgba(30, 30, 30, 0.8);\n            color: #ffffff;\n        }\n\n        ._bidding_dropdown {\n            display: flex;\n            align-items: center;\n            margin-left: 10px;\n\n            ._bidding_coin {\n                display: flex;\n                align-items: center;\n                cursor: pointer;\n            }\n\n            ._bidding_menu {\n                position: absolute;\n                top: -40px;\n                right: 0;\n                background-color: rgba(30, 30, 30, 0.9);\n                border-radius: 10px;\n                padding: 5px 0;\n\n                p {\n                    padding: 8px 15px;\n                    color: #d5d5d5;\n                    cursor: pointer;\n                    &:hover {\n                        background-color: rgba(255, 255, 255, 0.1);\n                    }\n                }\n            }\n        }\n    }\n\n    ._bidding_fast {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n        margin-top: 15px;\n\n        ._bidding_fast_input {\n            display: flex;\n            gap: 5px;\n            align-items: center;\n        }\n    }\n\n    ._bidding_button {\n        margin-top: 20px;\n        width: 100%;\n\n        Button {\n            font-size: 17px;\n            padding: 10px;\n            background-color: rgba(255, 255, 255, 0.1);\n            color: white;\n            &:hover {\n                background-color: rgba(255, 255, 255, 0.2);\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
